'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsHidden = exports.hiddenFormat = exports.getRelationnalAnnotations = exports.setAnnotationsLayout = exports.LAYOUT_ROW_SECTION = exports.LAYOUT_COLUMN = exports.LAYOUT_ROW = undefined;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var LAYOUT_ROW = exports.LAYOUT_ROW = 'LAYOUT_ROW';
var LAYOUT_COLUMN = exports.LAYOUT_COLUMN = 'LAYOUT_COLUMN';
var LAYOUT_ROW_SECTION = exports.LAYOUT_ROW_SECTION = 'LAYOUT_ROW_SECTION';
var ROWS = 'rows';
var HEADER = 'header';
var SECTIONS = 'sections';
var ORDER = 'ORDER';
var NOT_DISPLAYED = 'NOT_DISPLAYED';
var getType = R.propOr({}, 'type');
var getIds = function getIds() {
  var stringIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return R.pipe(R.append(R.split(',', stringIds)), R.flatten);
};
var getPivot = function getPivot(key, stringIds) {
  return R.over(R.lensProp(key), getIds(stringIds));
};
var setAnnotationsLayout = exports.setAnnotationsLayout = function setAnnotationsLayout(stringIds, layout) {
  return R.reduce(function (acc, annotation) {
    if (R.equals(getType(annotation), LAYOUT_ROW)) return getPivot(ROWS, stringIds)(acc);
    if (R.equals(getType(annotation), LAYOUT_COLUMN)) return getPivot(HEADER, stringIds)(acc);
    if (R.equals(getType(annotation), LAYOUT_ROW_SECTION)) return getPivot(SECTIONS, stringIds)(acc);
    return acc;
  }, layout);
};
var getRelationnalAnnotations = exports.getRelationnalAnnotations = function getRelationnalAnnotations(annotationIndexes) {
  return function (annotations) {
    return R.map(function (annotationIndex) {
      return R.propOr({}, annotationIndex)(annotations);
    })(annotationIndexes);
  };
};
var hiddenFormat = exports.hiddenFormat = {
  isHidden: true
};
var getIsHidden = exports.getIsHidden = function getIsHidden(annotations) {
  return R.pipe(R.find(R.propEq('type', NOT_DISPLAYED)), R.complement(R.isNil))(annotations);
};